import { BLOG_HERO_VIDEO } from '../media/blogHeroMedia';
import { normalizeBlogTopicKey } from '../components/blog/blogPostsData';
import {
  preloadBlogDetailHero,
  preloadBlogListingTopic,
} from './blogVideoCache';
import {
  preloadVideoUrl,
  prefetchBlogDetailRoute,
  prefetchBlogPageRoute,
} from './preloadMedia';

export function preloadBlogHeroVideo() {
  preloadVideoUrl(BLOG_HERO_VIDEO, { warmElement: true });
}

function readTopicFromLocation() {
  if (typeof window === 'undefined') return 'automation';
  const topic = new URLSearchParams(window.location.search).get('topic');
  return normalizeBlogTopicKey(topic);
}

/** Warm blog route + listing clips for current (or default) topic. */
export function prefetchBlogExperience() {
  preloadBlogHeroVideo();
  prefetchBlogPageRoute();
  import('../blog/blogVideos')
    .then(({ BLOG_VIDEO_POOL }) => {
      preloadBlogListingTopic(readTopicFromLocation(), BLOG_VIDEO_POOL);
    })
    .catch(() => {});
}

/** Hover / focus on a blog card — warm detail chunk + that article's hero clip only. */
export function prefetchBlogDetailById(postId) {
  const id = String(postId);
  prefetchBlogDetailRoute();
  import('../components/blog/blogPostsData')
    .then((mod) => {
      const post = mod.BLOG_POSTS_BY_ID[id] || mod.BLOG_POSTS_BY_SLUG?.[id];
      const cover = post?.coverImage || post?.image;
      if (cover) preloadBlogDetailHero(cover, { warm: true });
    })
    .catch(() => {});
}

export { preloadBlogListingTopic, preloadBlogDetailHero };
